export const roles = {
    superadmin: "1",
    admin: "2",
    sales: "3",
    electricup: "4",
}